import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl, UntypedFormGroup } from '@angular/forms';
import { PopulationState } from 'src/app/state-management';

@Component({
    selector: 'app-dnv-population',
    templateUrl: './dnv-population.component.html',
    styleUrls: ['./dnv-population.component.scss'],
    standalone: false
})
export class DnvPopulationComponent implements OnInit {
  @Input() populationState: PopulationState;
  @Output() populationSelectEmitter = new EventEmitter<any>();
  @Output() populationDrawEmitter = new EventEmitter<any>();
  @Output() populationClearEmitter = new EventEmitter<any>();

  populationForm: UntypedFormGroup;


  constructor() {
    // this.populationForm = new FormGroup({
    //   selectionMethod: new FormControl(),
    //   selectionBuffer: new FormControl()
    // });

  }

  ngOnInit(): void {
    // if (this.populationForm) {
    //   this.populationForm.get('selectionMethod').setValue(this.populationState.selectionMethod);
    // }
  }

  // ngOnChanges(changes: SimpleChanges) {
  //   if (changes.populationState) {
  //     this.populationForm.get('selectionMethod').setValue(this.populationState.selectionMethod);
  //   }
  // }

  populationSelect() {
    this.populationSelectEmitter.emit();
  }

  populationDraw() {
    this.populationDrawEmitter.emit();
  }

  mapClear() {
    this.populationClearEmitter.emit();
  }


}
